import React from 'react';
import PaymentCardSelectorView from './views/PaymentCardSelectorView';
import { usePaymentCardSelector } from './hooks/PaymentCardSelector.hook';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';

const PaymentCardSelectorController = () => {
  const {
    loading,
    error,
    cardTypes,
    selectedCard,
    openDropdownId,
    dropdownRef,
    handleCardSelect,
    toggleDropdown,
  } = usePaymentCardSelector();

  const languageData = useSelector(state => state.lenguage?.lang);
  const searchFormData = useSelector(state => state.searchFormData);
  const dispatch = useDispatch();

  const onSelectCard = card => {
    handleCardSelect(card);

    dispatch(
      setSearchFormData({
        ...searchFormData,
        paymentMethod: card,
      }),
    );

    window.history.back();
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <PaymentCardSelectorView
      loading={loading}
      error={error}
      languageData={languageData}
      onBack={handleBack}
      cardTypes={cardTypes}
      selectedCard={selectedCard}
      openDropdownId={openDropdownId}
      dropdownRef={dropdownRef}
      onSelectCard={onSelectCard}
      toggleDropdown={toggleDropdown}
    />
  );
};

export default PaymentCardSelectorController;
